/* eslint-disable camelcase */
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import isMobileDevice from 'utils/isMobileDevice';
import useExternalScript from 'utils/loadExternalScript';
import MobileFlow from './MobileFlow';
import DesktopFlow from './DesktopFlow';

const SocureProgress = () => {
  const {
    configs: { socureApiKey = undefined, socureSDKUrl = undefined },
    fields: {
      appRequest_primary_externalVerification_primaryVerification,
      // appRequest_primary_externalVerification_retryVerificationType,
      appRequest_primary_externalVerification_retryVerificationType,
      appRequest_secondary_externalVerification_retryVerificationType,

      appRequest_secondary_externalVerification_secondaryVerification,
      currentSigner_customer_externalVerification_retryVerificationType,
      currentSigner_customer_externalVerification_signersVerification,
    },
  } = useSelector((state) => state, shallowEqual);

  const isSocureEnabled = () =>
    !(
      appRequest_primary_externalVerification_primaryVerification?.hidden ||
      appRequest_secondary_externalVerification_secondaryVerification?.hidden ||
      currentSigner_customer_externalVerification_signersVerification?.hidden
    );

  const showRetryModal = () =>
    !(
      appRequest_primary_externalVerification_retryVerificationType?.hidden ||
      appRequest_secondary_externalVerification_retryVerificationType?.hidden ||
      currentSigner_customer_externalVerification_retryVerificationType?.hidden
    );

  const isMobile = isMobileDevice();
  const socureSDKScriptStatus = useExternalScript(
    isSocureEnabled() && socureApiKey?.length > 0 && socureSDKUrl,
  );

  if (socureSDKScriptStatus !== 'ready' || !isSocureEnabled() || showRetryModal()) {
    return <></>;
  }

  if (isMobile) {
    return <MobileFlow />;
  }
  return <DesktopFlow />;
};

export default SocureProgress;
